if (!customElements.get('ksl-scroll-story')) {
  customElements.define('ksl-scroll-story', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.chapters = [...this.querySelectorAll('[data-chapter]')];
      this.stage = this.querySelector('[data-stage]');
      this.preference = matchMedia('(prefers-reduced-motion: reduce)');
      this.viewport = matchMedia('(min-height: 600px)');
      this.stage.replaceChildren(...this.chapters.map(chapter => {
        const figure = chapter.querySelector('figure').cloneNode(true);
        figure.removeAttribute('aria-labelledby');
        return figure;
      }));
      this.slides = [...this.stage.children];
      this.configure = () => {
        this.enabled = this.chapters.length > 1 && !this.preference.matches && this.viewport.matches && document.body.hasAttribute('data-ksl-motion') && !window.Shopify?.designMode;
        this.classList.toggle('is-enhanced', this.enabled);
        this.update();
      };
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      };
      addEventListener('scroll', this.schedule, { passive: true, signal });
      addEventListener('resize', this.schedule, { passive: true, signal });
      this.preference.addEventListener('change', this.configure, { signal });
      this.viewport.addEventListener('change', this.configure, { signal });
      this.configure();
    }
    update() {
      if (!this.enabled) return;
      const mobile = innerWidth < 750;
      const stage = this.stage.getBoundingClientRect();
      const focus = mobile ? Math.max(stage.bottom + 60, innerHeight * .72) : innerHeight * .55;
      const tops = this.chapters.map(chapter => chapter.getBoundingClientRect().top);
      this.slides.forEach((slide, index) => {
        const progress = index === 0 ? 1 : Math.max(0, Math.min(1, (focus - tops[index] + 100) / 200));
        slide.style.clipPath = `inset(0 0 0 ${(1 - progress) * 100}%)`;
        slide.style.transform = `translateX(${(1 - progress) * 4}%)`;
      });
    }
    disconnectedCallback() {
      this.abort?.abort();
      cancelAnimationFrame(this.frame);
      this.frame = null;
      this.classList.remove('is-enhanced');
    }
  });
}
